import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./ServicesBar.css";
import {
  ProfDrivers,
  CarServicesCare,
  FastagMore,
} from "../../AllImportFiles/ImportSvg";
import Partner from "../Partner/Partner";
import InsuranceRenewal from "../InsuranceRenewal/InsuranceRenewal";
import CarMaintenance from "../CarMaintenance/CarMaintance";
import ReactGA from  "react-ga4";

function ServicesBar() {
  const navigate = useNavigate();
  const handleFastTagLink = () => {
    ReactGA.gtag("event", "hp_services_clicked", {    
      event_category: "box", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "fastag",
      button : "service"
    });
    navigate("/recharge-fastag");
  };
  const handleCarWashPage = () => {
    // window.location.href = "https://www.driveu.in/car-care";
    ReactGA.gtag("event", "hp_services_clicked", {
      event_category: "box", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "wash",
      button : "service"
    });
    
    navigate("/car-wash");
  };
  const handleProfessionalDrivers = () =>{
    ReactGA.gtag("event", "hp_services_clicked", {
      event_category: "box", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "drivers",
      button : "service"
    });
    navigate("/hire-drivers");
  }

  const handleDriverCoins = () =>{
    ReactGA.gtag("event", "hp_services_clicked", {
      event_category: "box", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "coins",
      button : "learn_more"
    });
    navigate("/driveu-coins");
  }

  return (
    <div className="servicesbar-wrapper">
      {/* Section displaying the services options */}
      <div className="services_options">
        <div className="our_services">Our Services</div>
        <div className="services_main" >
          {/* Link to Hire Drivers section */}
          <div  className="box_services">
            <div className="prof_drivers"  onClick = {handleProfessionalDrivers}>
              <center>
                {/* SVG icon for Professional Drivers */}
                <ProfDrivers className="services_name" />
              </center>
              <div className="prof_wrapper">
                <h2 style={{ color: "black" }} className="prof_heading">
                  Professional Drivers
                </h2>
                <div className="prof_content">
                  Hire verified, professional drivers for hassle-free commutes,
                  running errands and safe after-party drops on an hourly basis
                </div>
              </div>
            </div>
          </div>

          {/* Car Wash section */}
          <div className="box_services">
            <div className="car_care_services" onClick={handleCarWashPage}>
              <center>
                {/* SVG icon for Car Wash */}
                <CarServicesCare className="services_name" />
              </center>
              <div className="car_care_wrapper">
                <h2 className="prof_heading">Car Wash</h2>
                <div className="prof_content car_care_content">
                  Pressure wash, eco wash & daily wash by trained executives
                  equipped with high-grade machines and premium materials
                </div>
              </div>
            </div>
          </div>

          {/* Recharge FASTag section */}
          <div className="box_services">
            <div className="earn_driveu_coins" onClick={handleFastTagLink}>
              <center>
                {/* SVG icon for Recharge FASTag */}
                <FastagMore className="services_name" />
              </center>
              <div className="earn_driveu_wrapper">
                <h2 className="prof_heading">Recharge FASTag</h2>
                <div className="prof_content">
                  Zip through the toll-gates on your outstation trips without
                  any worries. Recharge your FASTag in just a few taps
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile version of services options */}
        <div className="services-main-mobile">
          {/* Link to Hire Drivers section */}
          <div onClick = {handleProfessionalDrivers} className="box-services-mobile">
            <div className="svg-mobile-services">
              <ProfDrivers className="svg-services" />
            </div>
            <div className="text-mobile-services">
              <section>Professional Drivers</section>
              <article>
                Hire verified, professional drivers for hassle-free commutes,
                running errands, and safe after-party drops on an hourly basis
              </article>
            </div>
          </div>

          {/* Car Wash section */}
          <div onClick={handleCarWashPage} className="box-services-mobile">
            <div className="svg-mobile-services">
              <CarServicesCare className="svg-services" />
            </div>
            <div className="text-mobile-services">
              <section>Car Wash</section>
              <article>
                Pressure wash, eco wash & daily wash by trained executives
                equipped with high-grade machines and premium materials
              </article>
            </div>
          </div>

          {/* Recharge FASTag section */}
          <div onClick={handleFastTagLink} className="box-services-mobile">
            <div className="svg-mobile-services">
              <FastagMore className="svg-services" id="svg-services-earn" />
            </div>
            <div className="text-mobile-services">
              <section>Recharge FASTag</section>
              <article>
                Zip through the toll-gates on your outstation trips without any
                worries. Recharge your FASTag in just a few taps
              </article>
            </div>
          </div>
        </div>
      </div>

      {/* Partner section */}
      <div className="partner">
        <Partner />
      </div>

      {/* Car Maintenance section */}
      <div className="carmaintance">
        <CarMaintenance />
      </div>

      {/* Insurance Renewal section */}
      <div className="partner">
        <InsuranceRenewal />
      </div>

      {/* Buy/Sell Used Cars section */}
      <div className="buy_sell_used_cars">
        <div className="imgDiv_car">
          <img
            src="https://ik.imagekit.io/driveu/Web/coin-section_1_RQzc_UA31.png"
            alt="Earn DriveU Coin"
            className="car_image"
          />
        </div>
        <div className="content_buy_sell_fold">
          <h2 className="buy_sell_heading">Earn DriveU Coins</h2>
          <div className="text_content_buy_sell">
            DriveU is rewarding car ownership. Earn DriveU Coins and redeem
            exciting offers, rewards, cashback, and vouchers on the DriveU app.
            Get rewarded for every transaction.
          </div>
          <div
            style={{ color: "white" }}
            className="buy_sell_btn"
            onClick = {handleDriverCoins}
          >
            <button className="buy_sell_btn">Learn More</button>
          </div>
        </div>
      </div>

      {/* Mobile version of Buy/Sell Used Cars section */}
      <div className="buysell-mobile">
        <div className="buysell-mobile">
          <div className="buysell-imagediv">
            <img
              src="https://ik.imagekit.io/driveu/Web/coin-section_1_RQzc_UA31.png"
              alt="Earn DriveU Coin"
              className="carimage-mobile"
            />
          </div>
          <div className="buysell-contentdiv">
            <h2 className="buysellhead-mobile">Earn DriveU Coins</h2>
            <div className="textcontent-mobile">
              DriveU is rewarding car ownership. Earn DriveU Coins and redeem
              exciting offers, rewards, cashback, and vouchers on the DriveU
              app. Get rewarded for every transaction.
            </div>
            <div onClick={ handleDriverCoins } className="learnMoreSell">
              <button className="buysell-btn-mobile">Learn&nbsp;More</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesBar;
